import { useMemo, useState, useEffect } from "react";
import { Link, useParams } from "react-router-dom";
import useGetData from "../../../hook/getData";
import { GetBlogCategories, GetBlogs, GetBlogTags } from "../../../services/client/blog/getBlogCategories";

const CategoryBlogPage = () => {

    const { data: categoiresBlog } = useGetData(['categories-blog'], GetBlogCategories);
    const { data: tags } = useGetData(['tags-blog'], GetBlogTags);
    const { data: blogs } = useGetData(['blogs'], GetBlogs);

    const { slug } = useParams();

    const [search, setSearch] = useState("");
    const [selectedCategories, setSelectedCategories] = useState<number[]>([]);
    const [selectedTags, setSelectedTags] = useState<number[]>([]);
    const [onlyFeatured, setOnlyFeatured] = useState(false);

    const toggleCategory = (id: number) => {
        setSelectedCategories((prev) =>
            prev.includes(id)
                ? prev.filter((c) => c !== id)
                : [...prev, id]
        );
    };

    const toggleTag = (id: number) => {
        setSelectedTags((prev) =>
            prev.includes(id)
                ? prev.filter((t) => t !== id)
                : [...prev, id]
        );
    };

    useEffect(() => {
        if (!slug || !categoiresBlog?.categories) return;

        const category = categoiresBlog.categories.find(
            (cat: any) => cat.slug === slug
        );

        if (category) {
            setSelectedCategories([category.id]);
        }
    }, [slug, categoiresBlog]);

    const filteredBlogs = useMemo(() => {
        if (!blogs?.posts?.data) return [];

        return blogs.posts.data
            .filter((blog: any) => {
                const title = blog.title || "";

                const matchSearch =
                    title.toLowerCase().includes(search.toLowerCase());

                const blogCategories = blog.categories || [];
                const blogTags = blog.tags || [];

                const matchCategory =
                    selectedCategories.length === 0
                        ? true
                        : blogCategories.some((cat: any) =>
                            selectedCategories.includes(cat.id)
                        );

                const matchTag =
                    selectedTags.length === 0
                        ? true
                        : blogTags.some((tag: any) =>
                            selectedTags.includes(tag.id)
                        );

                const matchFeatured =
                    !onlyFeatured ? true : blog.is_futed === 1;

                return matchSearch && matchCategory && matchTag && matchFeatured;
            })
            .reverse();
    }, [blogs, search, selectedCategories, selectedTags, onlyFeatured]);

    return (
        <section className="bg-white py-md-5 py-4">
            <div className="container">
                <div className="row gy-3">
                    <div className="col-lg-3 col-md-4">
                        <div className="card product-swicher position-sticky card-body border-0 shadow rounded rounded-4">
                            <input
                                type="search"
                                className="form-control py-3 mb-4"
                                placeholder="جستجو بر اساس عنوان..."
                                value={search}
                                onChange={(e) => setSearch(e.target.value)}
                            />

                            <div className="accordion" id="blogFilterAccordion">
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button
                                            className="accordion-button bg-white shadow-none collapsed"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#categoryCollapse"
                                        >
                                            دسته‌بندی‌ها
                                        </button>
                                    </h2>
                                    <div id="categoryCollapse" className="accordion-collapse collapse">
                                        <div className="accordion-body">

                                            {categoiresBlog?.categories?.map((cat: any) => (
                                                <div key={cat.id} className="form-check mt-2">
                                                    <input
                                                        className="form-check-input border-black border"
                                                        type="checkbox"
                                                        checked={selectedCategories.includes(cat.id)}
                                                        onChange={() => toggleCategory(cat.id)}
                                                    />
                                                    <label className="form-check-label">
                                                        {cat.name}
                                                    </label>
                                                </div>
                                            ))}

                                            <div className="text-end">
                                                <button
                                                    className="btn btn-sm mt-2"
                                                    onClick={() => setSelectedCategories([])}
                                                >
                                                    حذف فیلتر
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="accordion-item">
                                    <h2 className="accordion-header">
                                        <button
                                            className="accordion-button bg-white shadow-none collapsed"
                                            type="button"
                                            data-bs-toggle="collapse"
                                            data-bs-target="#tagCollapse"
                                        >
                                            تگ‌ها
                                        </button>
                                    </h2>
                                    <div id="tagCollapse" className="accordion-collapse collapse">
                                        <div className="accordion-body">

                                            {tags?.tags?.map((tag: any) => (
                                                <div key={tag.id} className="form-check mt-2">
                                                    <input
                                                        className="form-check-input border-black border"
                                                        type="checkbox"
                                                        checked={selectedTags.includes(tag.id)}
                                                        onChange={() => toggleTag(tag.id)}
                                                    />
                                                    <label className="form-check-label">
                                                        {tag.name}
                                                    </label>
                                                </div>
                                            ))}

                                            <div className="text-end">
                                                <button
                                                    className="btn btn-sm mt-2"
                                                    onClick={() => setSelectedTags([])}
                                                >
                                                    حذف فیلتر
                                                </button>
                                            </div>

                                        </div>
                                    </div>
                                </div>

                            </div>

                        </div>
                    </div>

                    <div className="col-lg-9 col-md-8">
                        <div className="card card-body border-0 rounded-4 shadow">
                            <div className="d-flex justify-content-between align-items-center mb-4">
                                <h5 className="mb-0">مقالات</h5>
                                <div className="form-check form-switch">
                                    <input
                                        className="form-check-input"
                                        type="checkbox"
                                        id="featuredSwitch"
                                        checked={onlyFeatured}
                                        onChange={() => setOnlyFeatured((prev) => !prev)}
                                    />
                                    <label className="form-check-label" htmlFor="featuredSwitch">
                                        پیشنهاد سردبیر
                                    </label>
                                </div>
                            </div>

                            <div className="row">
                                {filteredBlogs.length > 0 ? (
                                    filteredBlogs.map((blog: any) => (
                                        <div className="col-md-4 col-lg-3 mb-4" key={blog.id}>
                                            <Link className='text-decoration-none mb-3' to={`/blog/detail/${blog.slug}`}>
                                                <div className="card rounded-4 border-0 shadow-sm card-body blog-item-card">
                                                    <img
                                                        className="img-fluid rounded-3"
                                                        src={`https://dash.arascome.com/uploads/files/blog/posts/${blog.image}`}
                                                        alt={blog.title}
                                                    />

                                                    <div className="mt-3">
                                                        <div className="blog-toggle">
                                                            {blog.categories?.[0]?.name}
                                                        </div>

                                                        <h6 className="fw-bold text-black mt-3 text-split">
                                                            {blog.title}
                                                        </h6>
                                                        <div className='d-flex justify-content-between mt-3'>
                                                            <p className='text-muted font-medium mb-0'>
                                                                ادمین ارس کام
                                                            </p>
                                                            <span className='font-medium text-muted'>اردیبهشت 1405</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Link>
                                        </div>
                                    ))
                                ) : (
                                    <div className="text-center py-5">
                                        <p className="text-muted mb-0">موردی یافت نشد</p>
                                    </div>
                                )}
                            </div>

                        </div>
                    </div>

                </div>
            </div>
        </section>
    );
};

export default CategoryBlogPage;
